/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { workbookActions } from './slice';
import { API } from './constants';

/**
 * Workbook data export url generator function to obtain data for PDF
 * @param {*} param0
 */
export function* getPdfExportUrlGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_PDF_EXPORT_URL, payload);
    yield put(workbookActions.getWorkbookPdfExportUrlSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getWorkbookPdfExportUrlFailed(error?.message));
  }
}
/**
 * Workbook data export url generator function to obtain data for PDF
 * @param {*} param0
 */
export function* getPdfExportGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_PDF_EXPORT, payload);
    yield put(workbookActions.getWorkbookPdfExportSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getWorkbookPdfExportFailed(error?.message));
  }
}
/**
 * Get rate plan data generator function to get organization related data
 * @param {*} param0
 */
export function* getRateDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(workbookActions.getRatePlanDataSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getRatePlanDataFailed(error?.message));
  }
}
/**
 * Get room type data generator function to get organization related data
 * @param {*} param0
 */
export function* getRoomTypeDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(workbookActions.getRoomTypeDataSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getRoomTypeDataFailed(error?.message));
  }
}
/**
 * Get pace data generator function to get organization related data
 * @param {*} param0
 */
export function* getPaceDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(workbookActions.getPaceDataSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getPaceDataFailed(error?.message));
  }
}
/* Workbook data export url generator function to obtain data for PDF
 * @param {*} param0
 */
export function* getIataExportGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(workbookActions.getIataDataSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getIataDataFailed(error?.message));
  }
}
/**
 * Get consortia data generator function to get organization related data
 * @param {*} param0
 */
export function* getConsortiaDataGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_JS_VISUAL_DATA, payload);
    yield put(workbookActions.getConsortiaSucceeded(response));
  } catch (error) {
    yield put(workbookActions.getConsortiaFailed(error?.message));
  }
}
//
export function* workbookReportSaga() {
  yield takeLatest(workbookActions.getWorkbookPdfExportUrl.type, getPdfExportUrlGenerator);
  yield takeLatest(workbookActions.getRatePlanData.type, getRateDataGenerator);
  yield takeLatest(workbookActions.getPaceData.type, getPaceDataGenerator);
  yield takeLatest(workbookActions.getIataData.type, getIataExportGenerator);
  yield takeLatest(workbookActions.getConsortiaData.type, getConsortiaDataGenerator);
  yield takeLatest(workbookActions.getRoomTypeData.type, getRoomTypeDataGenerator);
}
//
export default workbookReportSaga;
